import {type ReactNode} from "react";

interface PageFooterProps {
    left: ReactNode;
    center?: ReactNode;
    right: ReactNode;
}

export const PageFooter = ({left, center, right}: PageFooterProps) => {
    return (
        <div className="d-flex flex-row justify-content-between align-items-baseline mt-4 p-4 border-top">
            <div className="d-flex gap-4">
                {left}
            </div>
            {center !== undefined && <div className="d-flex gap-4">{center}</div>}
            <div className="d-flex gap-4">
                {right}
            </div>
        </div>
    );
};
